export default __webpack_public_path__ + "static/media/Loincloth of the Reanimator.e49c950f.jpg";